module.exports = __webpack_public_path__ + "static/media/logo-ugmk.8901e3ed.png";